import { format } from "lib/globalize-util";

const messageStyle = {
    fontSize: "16px",
    lineHeight: "20px",
    marginTop: "auto",
    marginBottom: "auto",
    paddingTop: "0.75px",
    paddingBottom: "0.75px",
    marginLeft: "18px",
};
const defaultParams = {
    shouldUseLatestSnack: true,
    messageStyle,
    autoHideDuration: 5000,
};

type TParams = {
    snackbar: any;
    params?: {
        shouldUseLatestSnack: boolean;
        messageStyle: any;
        autoHideDuration: number;
    };
    type?: any;
};

const messages = {
    default: "Something went wrong exporting your order. Please try again.",
};

export const showAPIExceptionMessage = (args: TParams): void => {
    const parameters = { ...defaultParams, ...args.params };

    switch (args.type) {
        default:
            return args.snackbar({ message: format(messages.default), ...parameters });
    }
};
